<template>
  <div>
    <AdminNavbar />
    <div class="container mt-3 text-start">
      <CustomAlert
        title="Instructor Instructions"
        type="warning"
        icon="bi-exclamation-circle"
      >
        <p class="mb-0">Under development.</p>
      </CustomAlert>
    </div>
  </div>
</template>

<script>
import AdminNavbar from "@/admin/components/AdminNavbar";
import CustomAlert from "@/components/ui/CustomAlert";

export default {
  name: "SettingsView",
  components: {
    AdminNavbar,
    CustomAlert
  }
};
</script>
